import DocumentPlus from './DocumentPlus';

export default DocumentPlus;
